module.exports = __webpack_public_path__ + "fonts/lato-lightitalic-webfont.32fc0363.woff";